import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FiShield,
  FiLink2,
  FiLock,
  FiGrid,
  FiLayers,
  FiClock,
} from "react-icons/fi";
import patternImage from "../image/landing/designer/bg-patterns.webp";
import ctaImage from "../image/landing/designer/Tatt qr _img 4-creating-tattoo-on-hand.webp";
import "./Services.css";

const serviceItems = [
  {
    title: "Digital Identity",
    description:
      "Turn your tattoo into a live memory portal with images, audio, video, and text.",
    icon: FiShield,
  },
  {
    title: "Interaction System",
    description:
      "Every scan opens your personalized content instantly on mobile without app friction.",
    icon: FiLink2,
  },
  {
    title: "Access Control",
    description:
      "Keep moments private with PIN-protected content whenever you need lightweight privacy.",
    icon: FiLock,
  },
  {
    title: "Creator Dashboard",
    description:
      "Manage and switch active QR content from one dashboard without changing the tattoo.",
    icon: FiGrid,
  },
  {
    title: "Layered Storytelling",
    description:
      "Store multiple memories and set which one is currently visible to people who scan.",
    icon: FiLayers,
  },
  {
    title: "Timed Releases",
    description:
      "Use temporary content windows for special events, then fall back to permanent memories.",
    icon: FiClock,
  },
];

const Services = () => {
  const navigate = useNavigate();

  return (
    <section
      className="services-page"
      style={{ "--services-pattern-image": `url(${patternImage})` }}
    >
      <div className="services-shell">
        <p className="services-kicker">Our Services</p>
        <h1>Ecosystem Of Memory</h1>
        <p className="services-lead">
          TattQR combines physical ink with digital storytelling so each scan
          feels intentional, secure, and personal.
        </p>

        <div className="services-grid">
          {serviceItems.map((item) => {
            const Icon = item.icon;
            return (
              <article key={item.title} className="services-card">
                <span className="services-icon">
                  <Icon />
                </span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            );
          })}
        </div>

        <div
          className="services-cta"
          style={{ backgroundImage: `url(${ctaImage})` }}
        >
          <div className="services-cta-overlay" />
          <div className="services-cta-content">
            <h2>Build Your QR Story</h2>
            <p>
              Start with one QR, update your content anytime, and keep your
              tattoo timeless.
            </p>
            <button type="button" onClick={() => navigate("/signup")}>
              Design My QR
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
